import BaseClient from "./BaseClient";

export default class FakeAccessPayClient extends BaseClient {
    constructor(billingDate = null, tenantId: string) {
        super(billingDate, tenantId);
    }

    public accessPayBaseUrl: string;

    public async getSubmissions(accountNumber: string): Promise<Search[]> {
        const response = await this.get(`${this.accessPayBaseUrl}debug/submissions?accountNumber=${accountNumber}`);
        return await this.handleResponse<Search[]>(response, true);
    }

    public async getReports(reportType: string): Promise<Search[]> {
        const uri = `${this.accessPayBaseUrl}reports?reportType=${reportType}`;
        const response = await this.get(uri);
        return await this.handleResponse<Search[]>(response, true);
    }

    public async getReportById(reportId: string): Promise<string> {
        const uri = `${this.accessPayBaseUrl}reports/${reportId}`;
        const response = await this.get(uri);
        return await this.handleXmlResponse(response);
    }

    public async addAddacsReport(reasonCode: string, accountNumber: string,
        customerName: string, sortCode: string, bankAccountNumber: string,
        newSortCode: string, newBankAccountNumber: string) {
        const request = {
            advices: [
                {
                    payerName: customerName,
                    reference: accountNumber,
                    payerSortCode: sortCode,
                    payerAccountNumber: bankAccountNumber,
                    reasonCode: reasonCode,
                    payerNewSortCode: newSortCode,
                    payerNewAccountNumber: newBankAccountNumber
                }
            ]
        };
        const response = await this.post(`${this.accessPayBaseUrl}debug/reports/addacs`, request);
        return await this.handleResponse(response);
    }

    public async addAuddisReport(reasonCode: string, accountNumber: string,
        customerName: string, sortCode: string, bankAccountNumber: string) {
        const request = {
            reportType: "auddisinput",
            advices: [
                {
                    payerName: customerName,
                    reference: accountNumber,
                    payerSortCode: sortCode,
                    payerAccountNumber: bankAccountNumber,
                    reasonCode: reasonCode
                }
            ]
        };
        const response = await this.post(`${this.accessPayBaseUrl}debug/reports/auddis`, request);
        return await this.handleResponse(response);
    }

    public async addAruddReport(reasonCode: string, accountNumber: string,
        customerName: string, sortCode: string, bankAccountNumber: string, reasonDescription: string, amount: number,
        originalProcessingDate: Date, serviceUserNumber: string) {
        const request = {
            ReturnedDebitItems: [
                {
                    PayerName: customerName,
                    Reference: accountNumber,
                    ReturnCode: reasonCode,
                    ReturnDescription: reasonDescription,
                    Amount: amount,
                    BankAccountNumber: bankAccountNumber,
                    SortCode: sortCode,
                    originalProcessingDate: originalProcessingDate
                }
            ],
            ServiceUserNumber: serviceUserNumber
        };
        const response = await this.post(`${this.accessPayBaseUrl}debug/reports/arudd`, request);
        return await this.handleResponse(response);
    }

    public async clearReports() {
        const request = {};
        await this.post(`${this.accessPayBaseUrl}debug/reports/reset`, request);
    }

    private async handleXmlResponse(response: Response): Promise<string> {
        const contentType = response.headers.get('content-type');
        if (response.ok && contentType && contentType.indexOf('plain/text') !== -1) {
            const result = await response.text();
            if (result) {
                return result;
            }
            return null;
        }
        if (response.status === 404) {
            return null;
        }

        const errorResponse = await response.text() ?? 'Unknown Exception';
        throw JSON.parse(errorResponse);
    }
}

export const useFakeAccessPayClient = (billingDate = null, tenantId: string): FakeAccessPayClient => {
    return new FakeAccessPayClient(billingDate, tenantId);
};

export type Search = {
    id: string,
    content: string,
    submissionType: SubmissionType
}

export enum SubmissionType {
    Unknown,
    New,
    RequestPayment,
    Cancel
}
